// Entry file for splitted JS build variant (for browsers support module importing)
// https://caniuse.com/#feat=es6-module
// Module JS must be imported and registered in markup

import {autoInit} from '@mamdev/cad.static-next-lib';
import {getUrlPath} from '@mamdev/cad.static-next-lib';
import {App} from './base/app';

// Set static assets URL (for dynamic loading)
const jsFileName = 'entry.js';
const jsFilePath = getUrlPath(jsFileName);

const assetPath = {
  css: `${jsFilePath}/../css/${window.ui.tenant || 'mailcom'}`,
  js: jsFilePath,
  modules: jsFilePath.replace('/_sn_/js', '/_sn_/modules')
};

const app = App.instance;

// Bootstrap app when document is ready
const docReady = document.readyState;
if (docReady === 'interactive' || docReady === 'complete') {
  app.logger_.log('app', 'starting...');
  app.start(autoInit, assetPath);
} else {
  document.addEventListener('DOMContentLoaded', function() {
    app.start(autoInit, assetPath);
  });
}
